import React, { useState } from 'react';
import api from '../services/api';
import useToastStore from '../store/useToastStore';

const REPORT_REASONS = [
  'Fake or misleading listing',
  'Inappropriate content',
  'Spam or scam',
  'Wrong category',
  'Abusive behaviour',
  'Other',
];

export default function ReportModal({ targetType, targetId, targetName, onClose }) {
  const [reason, setReason] = useState('');
  const [details, setDetails] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!reason) return;
    setLoading(true);
    try {
      await api.post('/reports', { targetType, targetId, reason, details });
      useToastStore.getState().addToast('Report submitted. We\'ll review it shortly.', 'success');
      onClose();
    } catch (err) {
      const msg = err.response?.data?.error || 'Failed to submit report';
      useToastStore.getState().addToast(msg, 'error');
    }
    setLoading(false);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center"
      style={{ backdropFilter: 'blur(4px)', backgroundColor: 'rgba(0,0,0,0.6)' }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="bg-dark-surface border border-dark-border rounded-t-3xl w-full max-w-lg p-6 pb-10">
        <div className="w-10 h-1 bg-dark-border rounded-full mx-auto mb-5" />
        <h2 className="text-lg font-bold text-dark-text mb-1">Report</h2>
        <p className="text-dark-subtext text-sm mb-5">
          Report {targetType === 'SERVICE' ? 'this listing' : 'this user'}
          {targetName ? ` "${targetName}"` : ''}
        </p>

        <div className="space-y-2 mb-4">
          {REPORT_REASONS.map(r => (
            <button
              key={r}
              onClick={() => setReason(r)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl border text-sm font-medium text-left transition-colors ${
                reason === r
                  ? 'border-red-500/60 bg-red-500/10 text-dark-text'
                  : 'border-dark-border bg-dark-bg text-dark-subtext'
              }`}
            >
              <span className={`w-4 h-4 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${
                reason === r ? 'border-red-500' : 'border-dark-border'
              }`}>
                {reason === r && <span className="w-2 h-2 rounded-full bg-red-500 block" />}
              </span>
              {r}
            </button>
          ))}
        </div>

        {reason && (
          <textarea
            value={details}
            onChange={e => setDetails(e.target.value)}
            placeholder="Additional details (optional)…"
            rows={3}
            className="w-full bg-dark-bg border border-dark-border rounded-xl px-3 py-2 text-dark-text text-sm outline-none focus:border-red-500/50 resize-none mb-4"
          />
        )}

        <div className="flex gap-3">
          <button
            onClick={handleSubmit}
            disabled={!reason || loading}
            className="flex-1 py-3 rounded-xl bg-red-500 text-white font-semibold text-sm disabled:opacity-50"
          >
            {loading ? 'Submitting…' : 'Submit Report'}
          </button>
          <button
            onClick={onClose}
            className="flex-1 py-3 rounded-xl bg-dark-bg border border-dark-border text-dark-subtext font-medium text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
